import type {ComponentProps, ReactNode} from 'react';
import {AppProvider} from '@shopify/polaris';
// No exports map upstream — subpath resolves to the file directly (see VENDORED.md).
import enTranslations from '@shopify/polaris/locales/en.json';

/**
 * Every slj.app surface renders inside this. Kept trivial on purpose: the moment
 * app-specific config creeps in here, the two consumption modes (Hono document SSR
 * and React Router) drift apart. Extra AppProvider props (e.g. react-router's
 * `linkComponent`) are forwarded.
 */
export function PolarisProvider({
  children,
  ...rest
}: {children?: ReactNode} & Omit<ComponentProps<typeof AppProvider>, 'i18n'>) {
  return (
    <AppProvider i18n={enTranslations} {...rest}>
      {children}
    </AppProvider>
  );
}
